module.exports = __webpack_public_path__ + "img/turnover.d60942d6.png";